import { render } from "./WebsitePage.vue?vue&type=template&id=16268ea8"
import script from "./WebsitePage.vue?vue&type=script&lang=js"
export * from "./WebsitePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__